module.exports = __webpack_public_path__ + "media/images/ALLCARE_ACADEMY_Banner_2-871015292b0d66177446644e757e636a.jpg";